import React from 'react';
import './navitem.css';

const NavItem = (props) => {
    return ( 
        <>
        <li>
            <a className='link navitem' href={props.section}>{props.navitem}</a>
        </li>
        </>
     );
}
 
export default NavItem;